export default "__VITE_ASSET__Bk8P7mgX__"